import useSWR from 'swr'
import API from '../../../utils/api'
import { useToken } from '../auth/token'

let page = 1
let search = ''
let KEY: string | null = null

export function useEvents() {
	const { data: token } = useToken()

	if (page > 0) {
		KEY = `/event/list?page=${page}&search=${search}`
	}

	const { data, mutate } = useSWR<any>(
		KEY ? KEY : null,
		async () => {
			console.log('KEY', KEY)
			const response = await API.get(KEY + '', token + '', {})
			return response?.result
		},
		{ dedupingInterval: 10000 }
	)

	return {
		data,
		search,
		mutate: async (value?: any) => {
			if (value) {
				page = value
			}
			return mutate()
		},
		searchApi: async (value?: any) => {
			if (value !== undefined) {
				search = value
			}
			page = 1
			KEY = `/event/list?page=${page}&search=${search}`
			return mutate()
		},
		createEvent: async (value: any) => {
			const res = await API.send('POST', '/event/post', token + '', value)

			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
		deleteEvent: async (id?: any) => {
			const res = await API.send('DELETE', `/event/${id}`, token, {})

			if (res?.message === 'success') {
				console.log(res)
				return mutate()
			} else {
				return () => {}
			}
		},
		updateEvent: async (value: any) => {
			const res = await API.send(
				'PUT',
				`/event/${value.id}`,
				token + '',
				{
					title: value.title,
					content: value.content,
					images: value.images,
				}
			)
			if (res?.message === 'success') {
				return mutate()
			} else {
				return () => {}
			}
		},
	}
}
